// ======================================================================
// 📁 File: src/modules/ppe/components/machine-group/MachineGroupKpiBar.jsx
// 📝 Purpose:
//   KPI Bar for Machine Group Master
//   - Total groups
//   - Active groups
//   - Inactive groups
// ======================================================================

import React from "react";

export default function MachineGroupKpiBar({ rows = [] }) {
  const total = rows.length;
  const active = rows.filter((r) => r.is_active).length;
  const inactive = rows.filter((r) => !r.is_active).length;

  const Card = ({ title, value, color }) => (
    <div
      style={{
        flex: 1,
        background: "#fff",
        borderRadius: 12,
        padding: 16,
        display: "flex",
        alignItems: "center",
        gap: 12,
        boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
        borderLeft: `5px solid ${color}`,
      }}
    >
      <div>
        <div style={{ fontSize: 13, color: "#64748b" }}>
          {title}
        </div>
        <div
          style={{
            fontSize: 24,
            fontWeight: 600,
            color: "#0f172a",
          }}
        >
          {value}
        </div>
      </div>
    </div>
  );

  return (
    <div
      style={{
        display: "flex",
        gap: 16,
        marginBottom: 20,
      }}
    >
      <Card title="Total Machine Groups" value={total} color="#6366f1" />
      <Card title="Active Groups" value={active} color="#16a34a" />
      <Card title="Inactive Groups" value={inactive} color="#64748b" />
    </div>
  );
}
